module.exports = __webpack_public_path__ + "img/main-pic.91ed791d.png";